import { Button, Result, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

import styles from './style.module.less';

type NotAllowedProps = {
  title?: string;
  subTitle?: string;
  noExtra?: boolean;
};

export const NotAllowed = ({ title, subTitle, noExtra = false }: NotAllowedProps) => {
  const navigate = useNavigate();

  return (
    <Space align="center" className={styles[`not-found__space`]}>
      <Result
        status="403"
        title={title ?? `403`}
        subTitle={subTitle ?? `Desculpe, você não está autorizado a acessar essa página.`}
        extra={
          !noExtra && (
            <Button type="primary" onClick={() => navigate(`/`)}>
              Voltar para início
            </Button>
          )
        }
      />
    </Space>
  );
};
